import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import BgOrbs from "./BgOrbs";

const FAQS = [
  {
    q: "What content formats can AI Trainer ingest?",
    a: "PDFs, PPTs, videos (with transcripts), Word/Google docs, SOPs, spreadsheets, and plain text. You can also connect cloud drives and knowledge bases.",
  },
  {
    q: "Does this replace our existing LMS?",
    a: "No. AI Trainer sits alongside your LMS and focuses on AI-guided delivery and insight. We integrate so your existing library and tracking remain valuable.",
  },
  {
    q: "Can trainers still control session quality?",
    a: "Yes. Trainers can review, approve, edit, or lock sessions. AI generates the first draft—humans stay in control of the final learner experience.",
  },
  {
    q: "How does the AI tutor work?",
    a: "It delivers sessions step by step with context-aware explanations, examples, and checks for understanding. The tutor adapts pacing to each learner and is non-human by design.",
  },
  {
    q: "What analytics do trainers get?",
    a: "Completion rates, topic-level weak spots, engagement signals, drop-off points, at-risk learners, and AI-suggested interventions you can act on in a click.",
  },
  {
    q: "Is this enterprise-ready and secure?",
    a: "Yes. Role-based access, SSO, data residency options, audit logs, and enterprise-grade encryption in transit and at rest.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative min-h-screen flex items-center py-16 bg-gradient-to-b from-white via-blue-50/20 to-white overflow-hidden"
    >
      <BgOrbs variant="sky" />

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center">
          <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-blue-700">
            FAQ
          </div>
          <h2 className="mt-3 text-[34px] sm:text-[44px] leading-[1.08] font-extrabold tracking-tight text-slate-900 text-balance">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-12 bg-white/80 backdrop-blur-sm border border-slate-200 rounded-2xl p-2 sm:p-4 shadow-[0_16px_40px_-24px_rgba(15,23,42,0.15)]">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border-b border-slate-100 last:border-b-0 px-3"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left text-[15px] sm:text-[16px] font-semibold text-slate-900 hover:no-underline py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-[14.5px] text-slate-600 leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
